export default __webpack_public_path__ + "static/media/masaref-sanat.fd0ad790.png";